/**
 * @file   src\components\PasswordIcon.tsx
 * @brief  Html password component.
 * @date   Jun, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import React, { useState } from 'react';

import { InputProperty } from '../interfaces/generalInterface';
import PasswordactiveIcon from '../assets/images/icons/password';
import HidePasswordactiveIcon from '../assets/images/icons/hidepassword';

interface PassowrdIconInterface extends InputProperty {
  onChange: (str: React.ChangeEvent<HTMLInputElement>) => void;
  showpass: JSX.Element;
}

const CWPasswordInput = ({ onChange, id, name, type, value, placeholder, disabled, maxLength, icon, showpass, errorMessage, label,
  isMandatory,autoComplete }: PassowrdIconInterface) => {
  const onIconChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) onChange(e);
  };

  // State to handle show password
  const [flag_Password, setFlag_ShowPassword] = useState(false);

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setFlag_ShowPassword(!flag_Password);
  };

  return (
    <div className="form-group cw-input">
      <div className="cust-label-group pwd-field position-relative">
        <label htmlFor="label">
          {label}
          {isMandatory && <span className="mandatory">*</span>}
        </label>
        <input
          autoComplete={autoComplete}
          className={errorMessage && errorMessage !== '' ? 'form-control error' : value && value !== '' ? 'form-control active' : 'form-control'}
          id={id}
          name={name}
          type={flag_Password ? "text" : type}
          value={value}
          placeholder={placeholder}
          disabled={disabled}
          maxLength={maxLength}
          onChange={(event) => onIconChange(event)}
        />
        <span className="password-icon" onClick={togglePasswordVisibility}>
          {flag_Password ? <HidePasswordactiveIcon /> : <PasswordactiveIcon />}
        </span>
      </div>
      {errorMessage && errorMessage !== '' && <span className="error-msg">{errorMessage}</span>}

    </div>
  );
};

export default CWPasswordInput;
